import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as address from './types';

const mutations = {
  // 주소검색
  [address.SET_ADDRESS_LIST](state, data) {
    console.log('SET_ADDRESS_LIST');
    console.log(data);
    state.addressList.contents = data.juso;
    state.addressList.result = data.common;
  },
};

export default mutations;
